<template>
  <admin-layout :title="$t('create_x', { x: $t('User') })">
    <tec-form-section @submitted="submit">
      <template #title> {{ $t('create_x', { x: $t('User') }) }}</template>
      <template #description> {{ $t('Please fill the form below to add new record.') }}</template>

      <template #form>
        <div class="col-span-full lg:col-span-4 grid gap-6">
          <text-input
            :label="$t('Name')"
            v-model="form.name"
            :error="$page.props.errors.name ? $page.props.errors.name.replace('{attribute}', 'name') : null"
          />
          <text-input
            :label="$t('Username')"
            v-model="form.username"
            :error="$page.props.errors.username ? $page.props.errors.username.replace('{attribute}', 'username') : null"
          />
          <text-input
            type="email"
            :label="$t('Email')"
            v-model="form.email"
            :error="$page.props.errors.email ? $page.props.errors.email.replace('{attribute}', 'email') : null"
          />
          <text-input
            id="password"
            type="password"
            :label="$t('Password')"
            v-model="form.password"
            :error="$page.props.errors.password ? $page.props.errors.password.replace('{attribute}', 'password') : null"
          />
        </div>
        <div v-if="roles && roles.length" class="col-span-full flex flex-wrap items-center gap-x-6 gap-y-3">
          <label class="block w-full font-medium text-sm text-gray-700">{{ $t('Roles') }}</label>
          <template v-for="role in roles" :key="role.name">
            <check-box
              :id="role.name"
              :value="role.name"
              :label="$t(role.name)"
              v-model:checked="form.roles"
              :error="$page.props.errors.roles ? $page.props.errors.roles.replace('{attribute}', 'roles') : null"
            ></check-box>
          </template>
          <tec-input-error
            class="w-full mt-1"
            v-if="$page.props.errors.roles"
            :message="$page.props.errors.roles.replace('{attribute}', 'roles').replace('{min}', '1')"
          />
        </div>
      </template>

      <template #actions>
        <tec-action-message :on="form.recentlySuccessful" class="mr-3">{{ $t('Saved.') }}</tec-action-message>
        <loading-button type="submit" :loading="form.processing" :disabled="form.processing">{{ $t('Save') }}</loading-button>
      </template>
    </tec-form-section>
  </admin-layout>
</template>

<script>
import CheckBox from '@/Shared/CheckBox';
import TextInput from '@/Shared/TextInput';
import FileInput from '@/Shared/FileInput';
import AdminLayout from '@/Layouts/AdminLayout';
import LoadingButton from '@/Shared/LoadingButton';
import TecInputError from '@/Jetstream/InputError';
import TecFormSection from '@/Jetstream/FormSection';
import TecActionMessage from '@/Jetstream/ActionMessage';
import TecSecondaryButton from '@/Jetstream/SecondaryButton';

export default {
  props: ['roles'],

  components: {
    CheckBox,
    FileInput,
    TextInput,
    AdminLayout,
    LoadingButton,
    TecInputError,
    TecFormSection,
    TecActionMessage,
    TecSecondaryButton,
  },

  data() {
    return {
      form: this.$inertia.form({
        _method: 'POST',
        name: null,
        email: null,
        username: null,
        password: null,
        photo: null,
        roles: [],
      }),

      photoPreview: null,
    };
  },

  methods: {
    submit() {
      if (this.$refs.photo) {
        this.form.photo = this.$refs.photo.files[0];
      }

      this.form.post(route('users.store'));
    },
    selectNewPhoto() {
      this.$refs.photo.click();
    },
    updatePhotoPreview() {
      const reader = new FileReader();
      reader.onload = e => {
        this.photoPreview = e.target.result;
      };
      reader.readAsDataURL(this.$refs.photo.files[0]);
    },
    deletePhoto() {
      this.$inertia.delete(route('current-user-photo.destroy'), {
        preserveScroll: true,
        onSuccess: () => (this.photoPreview = null),
      });
    },
  },
};
</script>
